import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuditTrailComponent } from '../../shared/audit-trail/audit-trail-list/audit-trail.component';
import { AuditTrailData } from '../../shared/audit-trail/audit-trail.model';
import { AuditTrailFilterService } from '../../shared/audit-trail/audit-trail-filter.services';
import { routerTransition } from '../../shared/animations/router.animations';
import { MatDialog } from '@angular/material/dialog';
import { AuditTrailService } from '../../shared/audit-trail/audit-trail.service';
import { AccountService } from '../account.service';
import { QueryParamsService } from 'common';

@UntilDestroy()
@Component({
    selector: 'ifb-account-audit-trail',
    templateUrl: '../../shared/audit-trail/audit-trail-list/audit-trail.component.html',
    styleUrls: ['../../shared/audit-trail/audit-trail-list/audit-trail.component.scss'],
    animations: routerTransition,
    standalone: false
})
export class AccountAuditTrailComponent extends AuditTrailComponent {

  innerTabbed = true;
  params: any;

  constructor(
    public route: ActivatedRoute,
    public _auditTrailFilterService: AuditTrailFilterService,
    private auditService: AuditTrailService,
    private accountService: AccountService,
    private router: Router,
    public dialog: MatDialog,
    public queryParamsService: QueryParamsService) {
    super(dialog, route, _auditTrailFilterService, queryParamsService);
  }

  download(): void {
    // The loan id goes last: queryParams carries its own (undefined) loan, which would otherwise unscope the export.
    if (this.route.snapshot.params.id) {
      this.downloadForLoan(this.route.snapshot.params.id);
    } else if (this.route.snapshot.params.uniqueId) {
      this.accountService.getByUniqueId(this.route.snapshot.params.uniqueId)
        .pipe(untilDestroyed(this))
        .subscribe(loan => this.downloadForLoan(loan.id));
    }
  }

  accountAuditDetailsLink(audit: AuditTrailData, newWindow: boolean = false) {
    const path = `/audit/${audit.id}`;

    if (newWindow)
      window.open(path);
    else
      this.router.navigate([path]);
  }

  private downloadForLoan(loanId: number): void {
    this.params = this.queryParamsService.init({ ...this.queryParams, loan: loanId });
    this.auditService.auditDownload(this.params);
  }

}
